<nz-card class="header-card" nzSize="small">
  <div class="flex justify-start flex-wrap gap-0 xsm:gap-2">
    <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  </div>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xsm:!text-2xl my-0">{{ article.name }}</h2>
  </div>
</nz-card>

<nz-card class="!mt-4">
  <div class="flex justify-between items-start gap-5 flex-col">
    <div class="w-full h-[280px] overflow-hidden rounded-md">
      <img
        class="w-full h-full object-cover rounded-md"
        alt="Image"
        (error)="onImageError($event)"
        [src]="article.thumbnail.url"
      />
    </div>
    <div class="xl:basis-[60%]">
      <h5
        class="text-[#441752] !text-[13px] xsm:!text-lg border-t-transparent border-r-transparent border-l-transparent pb-4 border-b border-solid border-[#D9D9D9]"
      >
        {{ article.author }} | {{ this.formatDate(this.article.createdAt) }}
      </h5>
      <p
        class="font-[400] mt-6"
        [innerHTML]="serializeToHTML(this.article.description1)"
      ></p>

      <div *ngIf="this.article.media.url || this.article.link" class="flex flex-row gap-1  mt-4 items-center flex-wrap">
        <p class="mb-0">Explore related articles for more information:</p>
        <a [href]="this.article.media.url || this.article.link" target="_blank"
          class="cursor-pointer text-[#B08D23] py-0 px-4 custom-link font-normal">Learn More</a>
      </div>
    </div>
  </div>
</nz-card>
